import { DIAS_POR_VENCER, fechaLarga } from "@uirtus/shared";
import { Etiqueta } from "./ui";

type Tono = "neutro" | "exito" | "alerta" | "peligro";

/** Cuánto falta, dicho como lo diría una persona. */
export function textoDias(dias: number): string {
  if (dias < 0) {
    const n = Math.abs(dias);
    return `venció hace ${n} día${n === 1 ? "" : "s"}`;
  }
  if (dias === 0) return "vence hoy";
  if (dias === 1) return "vence mañana";
  return `en ${dias} días`;
}

export function tonoDias(dias: number): Tono {
  if (dias < 0) return "peligro";
  if (dias <= 30) return "alerta";
  if (dias <= DIAS_POR_VENCER) return "alerta";
  return "exito";
}

export function EstadoDominio({ dias, activo = true }: { dias: number; activo?: boolean }) {
  if (!activo) return <Etiqueta tono="neutro">Dado de baja</Etiqueta>;
  return <Etiqueta tono={tonoDias(dias)}>{textoDias(dias)}</Etiqueta>;
}

export const formatearFechaCorta = (iso: string): string =>
  new Intl.DateTimeFormat("es-MX", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  }).format(new Date(`${iso}T00:00:00Z`));

export { fechaLarga };
